import React from "react";

const VouchedTitle = ({ data }) => {
  return (
    <>
      <div>
        <p className="text-white mb-1">{data?.title}</p>
      </div>
      <div>
        <p>{data?.message}</p>
      </div>
    </>
  );
};

export default VouchedTitle;
